<div class="crm-read-only-container" *ngIf="readOnly; else formField">
  <div class="crm-field-label">{{ label | translate }}</div>
  <div class="crm-field-value">
    <!-- ng-container necessary since Angular interpolation will add empty space -->
    <ng-container *ngIf="control.value"> {{ control.value }} </ng-container>
  </div>
</div>
<ng-template #formField>
  <glxy-form-field>
    <glxy-label *ngIf="label">{{ label | translate }}</glxy-label>
    <input
      matInput
      [formControl]="control"
      [placeholder]="'MODEL_DRIVEN_FORM.ADD_FIELD_VALUE' | translate: { fieldName: label?.toLowerCase() }"
      type="number"
      inputmode="numeric"
      digitOnly
      [decimal]="true"
      [allowNegatives]="true"
      autocomplete="{{ disableAutoComplete }}"
      (blur)="saveField()"
    />
    <crm-model-driven-form-error
      [objectType]="objectType"
      [fieldId]="fieldId"
      [label]="label"
      [control]="control"
      [validation]="validation"
    ></crm-model-driven-form-error>
  </glxy-form-field>
</ng-template>
